import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
    name: 'safeurl'
})
export class SafeurlPipe implements PipeTransform {
    constructor(private sr: DomSanitizer) {}
    transform(value: any): any {
        const clean = DOMPurify.sanitize(value);

        return this.sr.bypassSecurityTrustHtml(clean);
    }
}
